export default __webpack_public_path__ + "static/media/studying-2.d36aff3c.png";